import { LoadSpinCommand } from "slotworks/commands/comms/load-spin-command";
import { StartSpinCommand } from "slotworks/commands/comms/start-spin-command";
import Components from "slotworks/components/components";
import BetModel from "slotworks/model/bets/bet-model";
import GameState from "slotworks/model/game-state";
import settingsModel from "slotworks/model/settings/settings-model";
import { Services } from "slotworks/services/services";
import { HoldSpinControl } from "slotworks/smart-ui/controls/spin/hold-spin-control";
import SmartUIFlags, { SmartUIFlag } from "slotworks/smart-ui/smart-ui-flags";
import State from "slotworks/state-machine/states/state";
import Contract from "slotworks/utils/contracts/contract";
import Parallel from "slotworks/utils/contracts/parallel";

export default class RequestSpin extends State {
    public static WINNINGS_RESET_DELAY: number = 0;

    private skipping: boolean;

    public onEnter(cascadeSkip?: boolean) {

        this.skipping = cascadeSkip;

        if (this.skipping) {
            SmartUIFlags.set(SmartUIFlag.NO_SKIP, true);
        }

        this.newGame();

        SmartUIFlags.set(SmartUIFlag.AWAITING_RESPONSE, true);

        Components.footer.showSpinStart(BetModel.getTotalStake());

        this.startSpinning().then(() => {
            if (!GameState.getCurrentGame().getCurrentRecord()) {
                this.error();
            } else {
                GameState.getCurrentGame().totalStake = BetModel.getTotalStake();
                if (this.skipping) {
                    this.skip();
                } else {
                    this.complete();
                }
            }
        });
    }

    public error() {
        Components.matrix.reset();
        Services.autoplay.stop();
        HoldSpinControl.cancel();
        settingsModel.setTurboSpin(false);

        SmartUIFlags.set(SmartUIFlag.NO_SKIP, false);

        super.error();
    }

    public onSkip() {
        SmartUIFlags.set(SmartUIFlag.NO_SKIP, true);
        this.skipping = true;
    }

    public onExit() {
        SmartUIFlags.set(SmartUIFlag.AWAITING_RESPONSE, false);
    }

    protected newGame() {
        GameState.newGame(BetModel.getTotalStake());

        Services.transaction.setDelayedWinnings(0, 0, RequestSpin.WINNINGS_RESET_DELAY).execute();
    }

    protected startSpinning(): Contract<any> {
        return new Parallel([
            () => StartSpinCommand(),
            () => LoadSpinCommand()
        ]);
    }
}
